export const SA_THEME_STORAGE_KEY = 'sa-theme'

export type SuperadminTheme = 'light' | 'dark'

export function isSuperadminTheme (value: string | null): value is SuperadminTheme {
  return value === 'light' || value === 'dark'
}

/** Lees opgeslagen thema; valt terug op light bij ontbrekende of ongeldige waarde. */
export function readStoredSuperadminTheme (): SuperadminTheme {
  try {
    const stored = localStorage.getItem(SA_THEME_STORAGE_KEY)
    if (isSuperadminTheme(stored)) return stored
  } catch {
    // private mode / storage disabled
  }
  return 'light'
}

export function writeStoredSuperadminTheme (theme: SuperadminTheme): void {
  try {
    localStorage.setItem(SA_THEME_STORAGE_KEY, theme)
  } catch {
    // negeer
  }
}
